export default "__VITE_ASSET__Cg3yeYUI__"